import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@aseed/ui/styles.css";
import "./styles/app.css";
import { App } from "./app/App";
import { I18nProvider } from "./app/i18n";

const root = document.getElementById("root");
if (!root) throw new Error("#root missing from index.html");

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </StrictMode>,
);
